import { useEffect, useState } from 'react'
import { gql, useQuery, useReactiveVar } from '@apollo/client'
import ProgressBar from 'components/ProgressBar/ProgressBar'
import DrawerSelect from 'components/Select/DrawerSelect'
import { TYPE } from 'baseui/select'
import { SiteLanguageVar } from 'lib/reactiveVars'
import { extractProfileByLanguage } from 'utils/languages'

// TODO Add create mew Style functionality....

export const GET_TAGS_FOR_SELECT = gql`
  query GET_TAGS_FOR_SELECT {
    findManyTag {
      id
      product_containers {
        id
      }
      tag_profiles {
        id
        name
        language
      }
    }
  }
`

const TagsSelect = ({ onChange, value, placeholder = null }) => {
  // Value is either null Or id of parent category.
  const [optionValues, setOptionValues] = useState(null)
  // === Site language
  const siteLanguage = useReactiveVar(SiteLanguageVar)
  // === GRAPHQL Query to get Languages

  const { loading, error, data } = useQuery(GET_TAGS_FOR_SELECT, {
    // -- Turning off, as referch queries are a lot more efficient
    // fetchPolicy: "cache-and-network",
  })

  useEffect(() => {
    if (value && data && tagOptions) {
      let selectedValues = [] as any
      for (const item of value) {
        const selectedValue = tagOptions.filter(
          (option) => option.id === item.id,
        )

        selectedValues = [...selectedValues, ...selectedValue]
      }
      setOptionValues(selectedValues)
    }
  }, [value, data])

  if (loading) return <ProgressBar infinite={true} value={100} />
  if (error) return <p>Query Error! {error.message}</p>

  const tagOptions = data.findManyTag.map((tag) => {
    const languageProfile = extractProfileByLanguage(
      siteLanguage,
      tag.tag_profiles,
    )

    const optionObject = {
      id: tag.id,
      name: languageProfile
        ? `${languageProfile.name} (${tag.product_containers.length})`
        : `ID: ${tag.id} - (Not translated) - ${siteLanguage.toUpperCase()}`,
    }
    return optionObject
  })

  const handleChange = (value) => {
    // Pass the value up (onChange)
    const selectedValuesList = value.map((item) => {
      return {
        id: item.id,
      }
    })

    onChange(selectedValuesList)
  }

  return (
    <DrawerSelect
      options={tagOptions}
      labelKey="name"
      valueKey="id"
      placeholder={placeholder ?? 'Select...'}
      onChange={(e) => handleChange(e.value)}
      value={optionValues}
      searchable={true}
      clearable={true}
      // ==== We revert to single style and collection (due to product page display)
      type={TYPE.search}
      multi
    />
  )
}

export default TagsSelect
